module.exports = __webpack_public_path__ + "static/media/edit-profile.94d14f51.png";